import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor} from '@elastic/eui';
import {SelectorPerfilesContainer as SelectorPerfiles} from '../../../../components/Selectores/Perfiles/container';

export const Formulario = (props)=>{

  let {onSave, selected, onClose} = props
  let [login, setLogin] = useState(selected ? selected.login : undefined);
  let [nombre, setNombre] = useState(selected ? selected.nombre : undefined);
  let [perfil,setPerfil] = useState(selected ? selected.idPerfil : undefined)
  let [email, setEmail] = useState(selected ? selected.email : undefined);
  
  const getData = () =>{
    let data = { login: login, nombre: nombre, idPerfil: perfil, email: email}
    if(selected){
      return {...selected,...data}
    }else{
      return data
    }
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const comprobarErrores = () => {
    return (isInvalidPerfil || isInvalidEmail)
  }

  const isInvalidLogin = useMemo(() => {return login===undefined || login.trim()===""},[login])
  const isInvalidNombre = useMemo(() => {return nombre===undefined || nombre.trim()===""},[nombre])
  const isInvalidPerfil = useMemo(() => {return perfil===undefined},[perfil])
  const isInvalidEmail = useMemo(() => {return email===undefined || email.trim()===""},[email])

  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Login" isInvalid={isInvalidPerfil}>
          <EuiFieldText fullWidth value={login} name="txtLogin" onChange={e => setLogin(e.target.value)} isInvalid={isInvalidLogin}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Nombre" isInvalid={isInvalidEmail}>
          <EuiFieldText fullWidth value={nombre} name="txtNombre" onChange={e => setNombre(e.target.value)} isInvalid={isInvalidNombre}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Perfil" isInvalid={isInvalidPerfil}>
          <SelectorPerfiles fullWidth valueOfSelected={perfil} onChange={value => setPerfil(value)} isInvalid={isInvalidPerfil}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Email" isInvalid={isInvalidEmail}>
          <EuiFieldText fullWidth value={email} name="txtEmail" onChange={e => setEmail(e.target.value)} isInvalid={isInvalidEmail}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;